module.exports = "./img/4cc71d8b75a67ea9e65b65f0a31f82b2.jpg";